/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { FraccioService } from '../../../controllers/Fraccio';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class FraccioPartialUpdateFormService extends YASAGPostFormService<__model.Fraccio> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      codi_fraccio: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(12), Validators.minLength(1), Validators.required]),
      nom_fraccio_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      nom_fraccio_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      nom_fraccio_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      explicacio_fraccio_ca: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      explicacio_fraccio_es: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      explicacio_fraccio_en: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      nota_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      nota_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      nota_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512)]),
      alt_ca: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      alt_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      alt_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      color_hex: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(7), Validators.minLength(1), Validators.required]),
      color_secund: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(7), Validators.minLength(1), Validators.required]),
      ordre: new FormControl({value: undefined, disabled: false}, [Validators.max(999999997), Validators.required]),
      visible: new FormControl({value: undefined, disabled: false}, []),
      fraccio_pare: new FormControl({value: undefined, disabled: false}, []),
      residus: new FormArray([], [Validators.required]),
      tipus_servei: new FormArray([], [Validators.required]),
      especial: new FormControl({value: undefined, disabled: false}, []),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
    codi_fraccio: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: FraccioService,
  ) {
    super('FraccioPartialUpdate', apiConfigService, ngZone);
    this.init();
  }

  public addDataResidus( residus: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['residus'];
    const fg = new FormGroup({
      residu: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      prioritat: new FormControl({value: undefined, disabled: false}, [Validators.max(999999997)]),
    }, []);
    __utils.addField(control,residus, fg, position, value);
  }

  public removeDataResidus( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['residus'];
    control.removeAt(i);
  }

  public addDataTipusServei( tipus_servei: number = 1, position?: number, value?: any): void {
    const control = <FormArray>this.form['controls']['data']['controls']['tipus_servei'];
    const fg = new FormGroup({
      tipus_servei: new FormControl({value: undefined, disabled: false}, [Validators.required]),
      informacio_secundaria_cat: new FormControl({value: undefined, disabled: false}, []),
      informacio_secundaria_es: new FormControl({value: undefined, disabled: false}, []),
      informacio_secundaria_en: new FormControl({value: undefined, disabled: false}, []),
      servei_fraccio_cat: new FormControl({value: undefined, disabled: false}, []),
      servei_fraccio_es: new FormControl({value: undefined, disabled: false}, []),
      servei_fraccio_en: new FormControl({value: undefined, disabled: false}, []),
    }, []);
    __utils.addField(control,tipus_servei, fg, position, value);
  }

  public removeDataTipusServei( i: number): void {
    const control = <FormArray>this.form['controls']['data']['controls']['tipus_servei'];
    control.removeAt(i);
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.Fraccio> {
    const result = val => this.service.partialUpdate(val);
    return this._submit('__model.Fraccio', result, 'data', value, true );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.Fraccio> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    while ((<FormArray>this.form['controls']['data']['controls']['residus']).length) {
      this.removeDataResidus(0);
    }
    if (value && value['data'] && value['data']['residus']) {
      this.addDataResidus(value['data']['residus'].length);
    }
    while ((<FormArray>this.form['controls']['data']['controls']['tipus_servei']).length) {
      this.removeDataTipusServei(0);
    }
    if (value && value['data'] && value['data']['tipus_servei']) {
      this.addDataTipusServei(value['data']['tipus_servei'].length);
    }
    super.reset(value, true); 
  }
  patch(value: typeof this.form.value): void {
    if (value && value['data'] && value['data']['residus']) {
      while (this.form.value['data']['residus'].length > 0) {
        this.removeDataResidus(0);
      }
      if (value['data']['residus'].length > this.form.value['data']['residus'].length) {
        this.addDataResidus(value['data']['residus'].length - this.form.value['data']['residus'].length);
      }
    }
    if (value && value['data'] && value['data']['tipus_servei']) {
      while (this.form.value['data']['tipus_servei'].length > 0) {
        this.removeDataTipusServei(0);
      }
      if (value['data']['tipus_servei'].length > this.form.value['data']['tipus_servei'].length) {
        this.addDataTipusServei(value['data']['tipus_servei'].length - this.form.value['data']['tipus_servei'].length);
      }
    }
    this.form.patchValue(value);
  }
}
